const router = [
  {
    path: "/lookList",
    meta: {
      title: "看货记录"
    },
    component: resolve => require(["../views/lookList/lookList"], resolve)
  },
  {
    path: "/lookChoose",
    meta: {
      title: "选择并上传货源"
    },
    component: resolve => require(["../views/lookChoose/lookChoose"], resolve)
  },
  {
    path: "/addLook",
    meta: {
      title: "新增看货记录"
    },
    component: resolve => require(["../views/addLook/addLook"], resolve)
  }
];

export default router;



// WEBPACK FOOTER //
// ./src/router/look.js